import { createStyles, makeStyles } from '@material-ui/core';

export const useKanbanBoardEmptyColumnStyles = makeStyles(() =>
    createStyles({
        root: {
            gap: 8,
            margin: 0,
            padding: '16px 0px',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center'
        },
        title: {
            margin: 0,
            fontSize: 18,
            lineHeight: 1,
            fontWeight: 600
        },
        description: {
            margin: 0,
            fontSize: 14,
            lineHeight: 1
        }
    })
);
